export default __webpack_public_path__ + "static/media/Group 1222.9ef9ceb1.png";